import {Determinant} from "./determinant";
import {SelectOperatorType} from "./select-operator";

export class SelectDeterminant extends Determinant {

  public selectValue: string;
  public operator: SelectOperatorType;

}
